import React, { useContext, useMemo } from 'react';
import { ProvidersContext } from '../context';
import { useAnnotationClickEvent } from '../hooks';
import { RendererContext } from '../../../ui/RendererActionsContext';
var AnnotationView = function AnnotationView(props) {
  var providers = useContext(ProvidersContext);
  var actionContext = useContext(RendererContext);
  var inlineCommentProvider = providers && providers.inlineComment;
  var updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
  var viewComponentProps = useAnnotationClickEvent({
    updateSubscriber: updateSubscriber,
    createAnalyticsEvent: props.createAnalyticsEvent
  });
  var ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
  var deleteAnnotation = useMemo(function () {
    return function (annotationInfo) {
      return actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type);
    };
  }, [actionContext]);
  if (ViewComponent && viewComponentProps) {
    var annotations = viewComponentProps.annotations,
      clickElementTarget = viewComponentProps.clickElementTarget;
    return /*#__PURE__*/React.createElement(ViewComponent, {
      annotations: annotations,
      clickElementTarget: clickElementTarget,
      deleteAnnotation: deleteAnnotation
    });
  }
  return null;
};
export { AnnotationView };